import { n as o, t } from "./l10n-1b905a9a.mjs";
const n = {
  methods: {
    n: o,
    t
  }
};
export {
  n as l
};
